const UNKNOWN_VALUES = new Set(['N/A', 'unknown']);

export const BU_ANNOTATION = 'graph.microsoft.com/business-unit-name';
export const PU_ANNOTATION = 'graph.microsoft.com/organization-unit-name';
export const MANAGER_EMAIL_ANNOTATION = 'graph.microsoft.com/manager-email';

export function stripManagerSuffix(title: string): string {
  return title.replace(/ \(MANAGER:.*\)$/i, '').trim();
}

export function nameFromEmail(email: string): string {
  if (!email || UNKNOWN_VALUES.has(email)) {
    return '—';
  }
  return email
    .split('@')[0]
    .split('.')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function emailToUserRef(email: string): string | null {
  if (!email || UNKNOWN_VALUES.has(email)) return null;
  const username = email.toLowerCase().replace('@', '_');
  return `user:default/${username}`;
}

export function annotationValue(
  entity: { metadata: { annotations?: Record<string, string> } },
  key: string,
): string {
  const value = entity.metadata.annotations?.[key];
  return !value || UNKNOWN_VALUES.has(value) ? '—' : value;
}
